export default {"src":"/_next/static/media/arrow-card-icon.a14f7300.svg","height":21,"width":13};